document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              // Only open if not already open (prevents double-opening)
              const modals = Alpine.store('modals');
              if (modals && !modals.rightDrawer?.open) {
                modals.open('cart');
              }
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
// --- FitPot: Drawer close scroll-unlock + focus reset (iOS fix) ---
(function () {
  function unlockScroll() {
    try {
      // Remove common scroll-lock patterns
      document.documentElement.classList.remove('overflow-hidden', 'overflow-y-hidden');
      document.body.classList.remove('overflow-hidden', 'overflow-y-hidden');

      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // If theme uses data attributes / state classes, clear the common ones too
      document.body.removeAttribute('data-scroll-lock');
    } catch (e) { }
  }

  function blurActive() {
    try {
      if (document.activeElement && typeof document.activeElement.blur === 'function') {
        document.activeElement.blur();
      }
    } catch (e) { }
  }

  function isDrawerOpen(wrapper) {
    if (!wrapper) return false;
    const style = window.getComputedStyle(wrapper);
    return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
  }

  function setupWatcher() {
    const slot = document.querySelector('#right-drawer-slot');
    if (!slot) return;

    // The wrapper is usually the element with x-show controlling visibility
    const wrapper =
      slot.closest('[x-show]') ||
      slot.closest('[data-modal]') ||
      slot.parentElement;

    if (!wrapper) return;

    let wasOpen = isDrawerOpen(wrapper);

    const obs = new MutationObserver(() => {
      const openNow = isDrawerOpen(wrapper);

      // Transition from open -> closed
      if (wasOpen && !openNow) {
        unlockScroll();
        // iOS: prevent “stuck pressed/focus” styles on buttons
        setTimeout(blurActive, 0);
        setTimeout(blurActive, 150);
      }

      wasOpen = openNow;
    });

    obs.observe(wrapper, {
      attributes: true,
      attributeFilter: ['style', 'class', 'aria-hidden'],
    });
  }

  // Run after DOM is ready (and again shortly after for Alpine-rendered nodes)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setupWatcher();
      setTimeout(setupWatcher, 500);
      setTimeout(setupWatcher, 1500);
    });
  } else {
    setupWatcher();
    setTimeout(setupWatcher, 500);
    setTimeout(setupWatcher, 1500);
  }
})();